import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TrackByFunction,
  ViewContainerRef,
  inject,
} from '@angular/core';
import {
  Activity,
  ActivityWithCategoryAndLocationsAndReportedDetails,
} from '@wilson/interfaces';
import {
  GanttIsActivityEndLocationMismatch,
  GanttIsActivityStartLocationMismatch,
  ShiftTimelinePipesModule,
} from '@wilson/shift-timeline/pipes';
import {
  ChangedKeyManagerService,
  DragAndDropModeService,
} from '@wilson/shift-timeline/services';
import { TimelineAutoSizeActivityCardComponent } from '../timeline-auto-size-shift-with-activities-card/TimelineAutoSizeActivityCard/timeline-auto-size-activity-card.component';

@Component({
  selector: 'wilson-auto-size-wrapper-for-data-with-activities',
  imports: [
    CommonModule,
    TimelineAutoSizeActivityCardComponent,
    ShiftTimelinePipesModule,
    GanttIsActivityStartLocationMismatch,
    GanttIsActivityEndLocationMismatch,
  ],
  templateUrl: './auto-size-wrapper-for-data-with-activities.component.html',
  styleUrl: './auto-size-wrapper-for-data-with-activities.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoSizeWrapperForDataWithActivitiesComponent {
  readonly viewRef = inject(ViewContainerRef);
  readonly dragAndDropModeService = inject(DragAndDropModeService);
  private changedKeyManagerService = inject(ChangedKeyManagerService);

  protected dirtyCastedActivities: ActivityWithCategoryAndLocationsAndReportedDetails[] =
    [];
  @Input({
    required: true,
  })
  accurateStartDateTime!: string;

  @Input({
    required: true,
  })
  accurateEndDateTime!: string;

  @Input({
    required: true,
  })
  set activities(value: Activity[]) {
    this.dirtyCastedActivities =
      value as ActivityWithCategoryAndLocationsAndReportedDetails[];
  }

  @Input({
    required: true,
  })
  containerWidthPx!: number | null;

  @Input({
    required: true,
  })
  accurateContainerDurationMs!: number;

  @Input() filteredActivityId!: string | null;
  @Input() isCursorGrab!: boolean;
  @Input() isActivityDraggable!: boolean;
  @Input() userId!: string | null;

  trackByActivities: TrackByFunction<ActivityWithCategoryAndLocationsAndReportedDetails> =
    (
      _: number,
      activity: ActivityWithCategoryAndLocationsAndReportedDetails,
    ) => {
      return this.changedKeyManagerService.computeChangedKeyForActivity(
        activity,
      );
    };

  handleSelectedActivity(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
